import { render, staticRenderFns } from "./CoursewareTasksDialogDistribute.vue?vue&type=template&id=e2275a70&"
import script from "./CoursewareTasksDialogDistribute.vue?vue&type=script&lang=js&"
export * from "./CoursewareTasksDialogDistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports